module.exports = "<div class=\"gw-modal-backdrop gw-fade\" ng-class=\"{'gw-in': animate}\" ng-style=\"{'z-index': 1050 + index*10}\"\r\n     ng-click=\"close($event)\"></div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/modal/templates/modal-backdrop-template.html
// module id = 587
// module chunks = 0